import axios from 'axios';
import { getBackendHost } from '../utils/backendHost';


const authConfig = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('jwt_authorization')}` },
});


export async function getAccountCleanupOverview() {
  const response = await axios.get(`${getBackendHost()}/v2/account-cleanup/overview`, authConfig());
  return response.data;
}


export async function createAccountCleanupPreview(payload) {
  const response = await axios.post(
    `${getBackendHost()}/v2/account-cleanup/previews`,
    payload,
    authConfig(),
  );
  return response.data;
}


export async function startAccountCleanup(payload) {
  const response = await axios.post(
    `${getBackendHost()}/v2/account-cleanup/jobs`,
    payload,
    authConfig(),
  );
  return response.data;
}


export async function getAccountCleanupJob(jobId) {
  const response = await axios.get(
    `${getBackendHost()}/v2/account-cleanup/jobs/${jobId}`,
    authConfig(),
  );
  return response.data;
}


export async function retryAccountCleanupJob(jobId) {
  const response = await axios.post(
    `${getBackendHost()}/v2/account-cleanup/jobs/${jobId}/retry`,
    {},
    authConfig(),
  );
  return response.data;
}


export async function protectAccountCleanupOrganization(organizationId, reason) {
  const response = await axios.put(
    `${getBackendHost()}/v2/account-cleanup/protections/${organizationId}`,
    { reason },
    authConfig(),
  );
  return response.data;
}


export async function unprotectAccountCleanupOrganization(organizationId) {
  const response = await axios.delete(
    `${getBackendHost()}/v2/account-cleanup/protections/${organizationId}`,
    authConfig(),
  );
  return response.data;
}
